import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { canAccesPrivateGuard } from '../shared/guards/can-acces-private.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
  },
  {
    path: 'public',
    loadChildren: () => import('./public/public.module').then(m => m.PublicModule),
  },
  {
    path: 'private',
    canActivate: [canAccesPrivateGuard],
    loadChildren: () => import('./private/private.module').then(m => m.PrivateModule),
  },
  {
    path: '**',
    redirectTo: '/dashboard',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MapsEditorRoutingModule {}
